import { css, styled } from "styled-components";

export const StyledHeaderStep = styled.div`
  width: auto;
  color: var(--white);
  font-family: Poppins;
  font-size: 0.75rem;
  font-weight: 520;
  ${(props) =>
    props.selected &&
    css`
      color: var(--blue-light);
    `}
`;
export const StyledHeaderStepContainer = styled.div`
  background-color: var(--catalina-blue);
  display: flex;
  justify-content: center;
  height: 32px;
  align-items: center;
`;
